// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m6wl6","fullView":"styles_fullView__Ubq2V","shimmer":"styles_shimmer__-vIRl"};